import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import useDemoTour from "@hooks/use-demo-tour";

import { addClassToBody } from "@stadium/helpers/dom";

export const GuideTourContext = createContext({});
export const useGuideTourContext = () => useContext(GuideTourContext);

const GuideTourProvider = ({ guidedTourOptions, children }) => {
  const { guideTourSteps: initialGuideTourSteps = {}, ...restOptions } = guidedTourOptions;

  const [guideTourSteps, setGuideTourSteps] = useState(initialGuideTourSteps);

  useEffect(() => setGuideTourSteps(initialGuideTourSteps), [initialGuideTourSteps]);

  const {
    setStep,
    step,
    renderTour,
    showGuideTour,
    setShowGuideTour,
    closeGuideTour,
    setIsLoading,
  } = useDemoTour({ guideTourSteps, ...restOptions });
  const { step1 = {} } = guideTourSteps;

  const startGuideTour = useCallback(
    (showGuideTour = true) => {
      setShowGuideTour(showGuideTour);
      setStep(1);
      addClassToBody(step1.targetClass);
    },
    [step1, setShowGuideTour, setStep],
  );

  const updateGuidedTourStep = useCallback(
    (newStepData, stepNumber) => {
      const newSteps = { ...guideTourSteps };
      newSteps[`step${stepNumber}`] = newStepData;

      setGuideTourSteps(newSteps);
    },
    [guideTourSteps],
  );

  const value = useMemo(
    () => ({
      renderTour,
      startGuideTour,
      guideTourSteps,
      tourStep: step,
      showGuideTour,
      setShowGuideTour,
      closeGuideTour,
      setIsLoading,
      updateGuidedTourStep,
    }),
    [
      renderTour,
      startGuideTour,
      guideTourSteps,
      step,
      showGuideTour,
      setShowGuideTour,
      closeGuideTour,
      setIsLoading,
      updateGuidedTourStep,
    ],
  );

  return <GuideTourContext.Provider value={value}>{children}</GuideTourContext.Provider>;
};
export default GuideTourProvider;
